export default class AuthRecoveryPassword {

    public password?: string;
    public confirmPassword?: string;
    public pin?: string;

    constructor(
        password: string | undefined,
        confirmPassword: string | undefined,
        pin: string | undefined
    ) {
        this.password = password;
        this.confirmPassword = confirmPassword;
        this.pin = pin;
    }

    public isValid(): any {
        return !!(this.password && this.confirmPassword && this.password.length >= 6
            && this.confirmPassword.length >= 6 && this.password === this.confirmPassword);
    }
    public formIsComplete(): any {
        return !!(this.password && this.confirmPassword)
    }
    public typeError(): any {
        if (!this.formIsComplete()) {
            return 'formIncomplete';
        } else if (!this.password || (this.password && this.password.length < 6)) {
            return 'passwordLengthInvalid';
        } else if (!this.password && !this.confirmPassword && this.password !== this.confirmPassword) {
            return 'passwordEqualInvalid';
        } else {
            return undefined;
        }
    }
}